// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SDjn","selected":"styles_selected__3K7ok"};